import { z } from 'zod';
import { validationMessage } from '../../../shared/i18n/zod';

export const credentialsSchema = z.object({
  email: z.email(validationMessage('email')),
  password: z.string().min(8, validationMessage('passwordMin')),
});
export type Credentials = z.infer<typeof credentialsSchema>;
export type CredentialsSubmit = (values: Credentials) => Promise<{ error: string | null }>;
